export enum SUPPORTED_FONT_FAMILY {
  MODERAT = 'MODERAT',
  PP_FRAGMENT = 'PP_FRAGMENT',
}

const PP_FRAGMENT = SUPPORTED_FONT_FAMILY.PP_FRAGMENT

export enum FFM_COMPONENT_KEY {
  BASE_TEXT = 'BASE_TEXT',
}

export enum FFM_COMPONENT_PROP_KEY {
  DISPLAY = 'DISPLAY',
  TITLE = 'TITLE',
  DEFAULT = 'DEFAULT',
}

export type FontFamilyMetadata = {
  default: SUPPORTED_FONT_FAMILY
  isAuroraMetadata: boolean
  // When true, body text uses REGULAR weight instead of LIGHT (only applies when isAuroraMetadata is true)
  useRegularBodyWeight?: boolean
  component?: {
    [FFM_COMPONENT_KEY.BASE_TEXT]?: {
      [FFM_COMPONENT_PROP_KEY.DISPLAY]: SUPPORTED_FONT_FAMILY
      [FFM_COMPONENT_PROP_KEY.TITLE]: SUPPORTED_FONT_FAMILY
      [FFM_COMPONENT_PROP_KEY.DEFAULT]?: SUPPORTED_FONT_FAMILY
    }
  }
}

export const defaultModeratFontFamilyMetadata: FontFamilyMetadata = {
  default: SUPPORTED_FONT_FAMILY.MODERAT,
  isAuroraMetadata: false,
}

export const auroraFontFamilyMetadata: FontFamilyMetadata = {
  ...defaultModeratFontFamilyMetadata,
  isAuroraMetadata: true,
  component: {
    [FFM_COMPONENT_KEY.BASE_TEXT]: {
      [FFM_COMPONENT_PROP_KEY.DISPLAY]: PP_FRAGMENT,
      [FFM_COMPONENT_PROP_KEY.TITLE]: PP_FRAGMENT,
    },
  },
}

// Connect uses PP Fragment for headlines/subheads but Moderat-Regular (not Light) for body text
export const connectFontFamilyMetadata: FontFamilyMetadata = {
  ...auroraFontFamilyMetadata,
  useRegularBodyWeight: true,
}

export const getFontFamilyFromMetadata = (
  fontFamilyMetadata: FontFamilyMetadata,
  componentKey?: FFM_COMPONENT_KEY,
  componentPropKey?: FFM_COMPONENT_PROP_KEY,
): SUPPORTED_FONT_FAMILY => {
  if (componentKey && componentPropKey && fontFamilyMetadata.component) {
    const componentKeyMapping = fontFamilyMetadata.component[componentKey]
    if (componentKeyMapping) {
      const componentPropKeyMapping = componentKeyMapping[componentPropKey]
      if (componentPropKeyMapping) {
        return componentPropKeyMapping
      }
    }
  }

  return fontFamilyMetadata.default
}
